export var EPIC_END = '@@redux-observable/EPIC_END';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-observable/lib/esm/EPIC_END.js
// module id = 557
// module chunks = 0